<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import StatChart from '@components/widget-stat-chart'
import Weather from '@/src/components/weather.vue'
import ViewerRegisterProspect from '@/src/components/register-prospect.vue'
import OverviewInformation from '@/src/services/overview_info'
import configuracaoService from '@/src/services/api-receituario/configuracao'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import empresaService from '@/src/services/empresa_sistema'
import weatherForecastService from '@/src/services/get-weather-forecasts'
import ExecutiveDashboardProfile12 from './components/executive/ExecutiveDashboardProfile12.vue'
import GestaoReceituarios from '@views/pages/register/gestao-receituarios.vue'
moment.locale('pt-br')

/**
 * Dashboard-1 Component
 */
export default {
  components: {
    Layout,
    Loading,
    StatChart,
    apexchart: VueApexCharts,
    ViewerRegisterProspect,
    Weather,
    ExecutiveDashboardProfile12,
    GestaoReceituarios,
  },
  data() {
    return {
      showTop: true,
      isLoading: false,
      total_pagar: 0,
      total_receber: 0,
      contas_vencidas: [],
      ultimas_receitas_emitidas: [],
      visitas: [],
      configuracao: '',
      empresa: {},
      weatherforecasts: [],
      statChart: [
        {
          mainTitle: 'Receitas Emitidas',
          value: 0,
          chartColor: '#5369f8',
        },
        {
          mainTitle: 'Receitas Canceladas',
          value: 0,
          chartColor: '#f77e53',
        },
        {
          mainTitle: 'Total Responsável Técnico',
          value: 0,
          chartColor: '#43d39e',
        },
        {
          mainTitle: 'Total Produtores',
          value: 0,
          chartColor: '#ffbe0b',
        },
      ],
      ultimasReceitasFields: [
        { key: 'data_emissao', label: 'Data de Emissão' },
        { key: 'numero_receita', label: 'Número da Receita' },
        { key: 'valor_nf', label: 'Valor' },
      ],
      visitasFields: [
        { key: 'tecnico', label: 'Técnico' },
        { key: 'cliente', label: 'Cliente' },
        { key: 'produto', label: 'Produto' },
        { key: 'data_hora', label: 'Data' },
      ],
      contaVencidaField: [
        {
          key: 'descricao',
          label: 'Descrição',
          class: 'size-col-20',
        },
        {
          key: 'data_vencimento',
          label: 'Vencimento',
          class: 'size-col-20',
        },
        {
          key: 'valor_final',
          label: 'Valor',
          class: 'size-col-20',
        },
        {
          key: 'tipo_operacao',
          label: 'Tipo da Conta',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: { categories: [] },
      },
      series: [{ data: [], name: 'receitas' }],
    }
  },
  computed: {
    isAdminSistema() {
      return this.$store.state.auth.currentUser && this.$store.state.auth.currentUser.user === 'admin_sistema'
    },
    isEmpresa12() {
      return Number(this.empresa.id_empresa_sistema) === 12 && !this.isAdminSistema
    },
    isEmpresa169() {
      return Number(this.empresa.id_empresa_sistema) === 169
    },
    todayKey() {
      const today = new Date()
      const day = today
        .getDate()
        .toString()
        .padStart(2, '0')
      const month = (today.getMonth() + 1).toString().padStart(2, '0')
      const year = today.getFullYear()
      return `${day}/${month}/${year}`
    },
  },
  watch: {},
  mounted() {
    window.localStorage.setItem('configuracao', '')
    this.listandoInformações()
    this.handleGetConfiguracao()
    this.getEmpresa()

    // let hubsPotScript = document.createElement('script')
    // hubsPotScript.setAttribute(
    //   'src',
    //   'https://js-na1.hs-scripts.com/8761732.js'
    // )
    // document.head.appendChild(hubsPotScript)
  },
  methods: {
    getEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
        this.getWeatherForecast()
      })
    },
    getWeatherForecast() {
      if (this.empresa != undefined && this.empresa.municipio != undefined) {
        let ibgeCode = this.empresa.municipio.ibge
        weatherForecastService.getWeatherForecast(ibgeCode).then((resposta) => {
          console.log(resposta.data[ibgeCode][this.todayKey])
          this.weatherforecasts = resposta.data[ibgeCode][this.todayKey]
        })
      }
    },

    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    listandoInformações() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      OverviewInformation.information(token)
        .then((response) => {
          console.log(response)
          this.statChart[0].value = response.data.receitas_emitidas
          this.statChart[1].value = response.data.receitas_canceladas
          this.statChart[2].value = response.data.total_agronomos
          this.statChart[3].value = response.data.total_produtores
          this.total_pagar = response.data.pagar
          this.total_receber = response.data.receber
          this.contas_vencidas = response.data.contas_vencidas
          this.ultimas_receitas_emitidas =
            response.data.ultimas_receitas_emitidas
          this.visitas = response.data.visitas

          console.log(response.data.ultimas_receitas_emitidas)

          this.chartOptions = {
            xaxis: {
              categories: Object.keys(response.data.receitas_por_mes),
            },
          }
          this.series = [
            {
              data: Object.values(response.data.receitas_por_mes),
            },
          ]
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    handleGetConfiguracao() {
      const token = this.$store.state.auth.currentUser.token
      configuracaoService.listar(token).then((response) => {
        this.configuracao = response.data.configuracoes[0]
        window.localStorage.setItem(
          'configuracao',
          JSON.stringify(this.configuracao)
        )
      })
    },
    abrirReceitas() {
      this.$router.push({ path: '/register/receita' });
    },
    abrirFluxoCaixa() {
      this.$router.push({ path: '/financeiro/fluxo-de-caixa' });
    },
  },
}
</script>

<template>
  <Layout>
    <template v-if="isEmpresa12">
      <ExecutiveDashboardProfile12 />
    </template>
    <template v-else-if="isEmpresa169">
      <GestaoReceituarios :no-layout="true" />
    </template>
    <template v-else>
    <div class="row page-title align-items-center"> </div>
    <div class="system-update-notice">
      <div class="system-update-notice__hero">
        <h3>Atualização do sistema</h3>
        <p>
          O que antes ficava concentrado no menu <strong>Receituário</strong> agora foi redistribuído entre os menus principais.
        </p>
      </div>

      <div class="system-update-notice__cards">
        <article class="system-update-notice__card">
          <div class="system-update-notice__icon-wrap">
            <feather type="file-text"></feather>
          </div>
          <div>
            <strong>Menu Receituário</strong>
            <span>Fluxo operacional das receitas e emissões.</span>
          </div>
        </article>
        <article class="system-update-notice__card">
          <div class="system-update-notice__icon-wrap">
            <feather type="database"></feather>
          </div>
          <div>
            <strong>Menu Cadastros</strong>
            <span>Produtores, responsáveis técnicos e demais bases cadastrais.</span>
          </div>
        </article>
        <article class="system-update-notice__card">
          <div class="system-update-notice__icon-wrap">
            <feather type="bar-chart-2"></feather>
          </div>
          <div>
            <strong>Menu Relatórios</strong>
            <span>Centraliza os relatórios do sistema.</span>
          </div>
        </article>
      </div>
    </div>
    <div class="row">
      <div v-for="stat of statChart" :key="stat.mainTitle" class="col-md-6 col-xl-3 d-flex align-items-stretch">
        <div class="card stat-card flex-grow-1" :style="{ borderLeft: `4px solid ${stat.chartColor}` }">
          <div class="card-body p-2">
            <div class="media">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold d-block">
                  {{ stat.mainTitle }}
                </span>
                <h2 class="mb-0">{{ stat.value }}</h2>
              </div>
              <div class="align-self-center">
                <apexchart class="apex-chart-widget" type="area" height="35" width="70" :series="stat.series"
                  :options="stat.chartOptions"></apexchart>
                <span class="text-success font-weight-bold font-size-13"
                  :class="{ 'text-danger': `${stat.subValue}` === '5.05%' }">
                  {{ stat.subValue }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm border-0 rounded-3">
          <div class="card-header bg-light d-flex align-items-center justify-content-between px-3 py-2">
            <h6 class="mb-0 fw-bold text-brand">
              <i class="fas fa-cloud-sun me-2"></i>
              Previsão do tempo —
              {{ weatherforecasts.manha && weatherforecasts.manha.entidade ? weatherforecasts.manha.entidade : 'Local'
              }}
              ({{ todayKey }})
            </h6>
          </div>

          <div class="card-body py-3 px-4">
            <div v-if="weatherforecasts.manha || weatherforecasts.tarde || weatherforecasts.noite">
              <p class="mb-2 text-muted small">
                <span class="fw-semibold text-dark">Manhã:</span>
                {{ weatherforecasts.manha ? weatherforecasts.manha.resumo : 'Sem dados' }} |
                Máx: {{ weatherforecasts.manha ? weatherforecasts.manha.temp_max : '-' }}°C |
                Mín: {{ weatherforecasts.manha ? weatherforecasts.manha.temp_min : '-' }}°C |
                Vento: {{ weatherforecasts.manha ? weatherforecasts.manha.dir_vento : '-' }}
                {{ weatherforecasts.manha ? weatherforecasts.manha.int_vento : '' }}
              </p>

              <p class="mb-2 text-muted small">
                <span class="fw-semibold text-dark">Tarde:</span>
                {{ weatherforecasts.tarde ? weatherforecasts.tarde.resumo : 'Sem dados' }} |
                Máx: {{ weatherforecasts.tarde ? weatherforecasts.tarde.temp_max : '-' }}°C |
                Mín: {{ weatherforecasts.tarde ? weatherforecasts.tarde.temp_min : '-' }}°C |
                Vento: {{ weatherforecasts.tarde ? weatherforecasts.tarde.dir_vento : '-' }}
                {{ weatherforecasts.tarde ? weatherforecasts.tarde.int_vento : '' }}
              </p>

              <p class="mb-0 text-muted small">
                <span class="fw-semibold text-dark">Noite:</span>
                {{ weatherforecasts.noite ? weatherforecasts.noite.resumo : 'Sem dados' }} |
                Máx: {{ weatherforecasts.noite ? weatherforecasts.noite.temp_max : '-' }}°C |
                Mín: {{ weatherforecasts.noite ? weatherforecasts.noite.temp_min : '-' }}°C |
                Vento: {{ weatherforecasts.noite ? weatherforecasts.noite.dir_vento : '-' }}
                {{ weatherforecasts.noite ? weatherforecasts.noite.int_vento : '' }}
              </p>
            </div>

            <div v-else class="text-center py-3 text-muted">
              <i class="fas fa-cloud-bolt me-2"></i> Não foi possível obter informações da previsão do tempo.
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row align-items-stretch gx-4 gy-4">
      <!-- Receita por Mês -->
      <div class="col-md-6 d-flex">
        <div class="card ui-card shadow-lg border-0 rounded-3 flex-grow-1">
          <div class="card-header ui-card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">
              <i class="fas fa-chart-column me-2 text-primary-600"></i>Receita por Mês
            </h5>
            <button class="btn btn-outline-primary btn-sm" @click="abrirReceitas">
              Ver Todos
            </button>
          </div>
          <div class="card-body p-0">
            <div class="p-3">
              <apexchart type="bar" height="300" :options="chartOptions" :series="series"
                class="apexchart-container w-100">
              </apexchart>
            </div>
          </div>
          <div class="card-footer bg-transparent py-2 px-3 small text-muted">
            Última atualização: {{ formatDate(new Date()) }}
          </div>
        </div>
      </div>

      <!-- Visitas em Campo -->
      <div class="col-md-6 d-flex">
        <div class="card ui-card shadow-lg border-0 rounded-3 flex-grow-1">
          <div class="card-header ui-card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">
              <i class="fas fa-person-walking-luggage me-2 text-primary-600"></i>Visitas em Campo
            </h5>
            <!-- <button class="btn btn-outline-primary btn-sm" @click="abrirReceitas">Ver Todos</button> -->
          </div>
          <div class="card-body p-0">
            <div class="table-responsive p-2">
              <b-table striped hover small borderless :items="visitas" :fields="visitasFields" :per-page="perPage"
                class="mb-0 ui-table">
                <template #cell(data_hora)="row">
                  {{ formatDate(row.item.data_hora) }}
                </template>
              </b-table>
            </div>
          </div>
          <div class="card-footer bg-transparent py-2 px-3 small text-muted">
            {{ visitas.length || 0 }} registros
          </div>
        </div>
      </div>
    </div>


    <div class="row align-items-stretch">
      <!-- Resumo Financeiro -->
      <div class="col-md-4 mb-4 d-flex">
        <div class="card shadow-lg border-0 rounded-lg flex-grow-1 card-min-height">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Resumo Financeiro</h5>
            <button class="btn btn-outline-primary btn-sm" @click="abrirFluxoCaixa">Ver Todos</button>
          </div>
          <div class="card-body p-0">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1 text-success font-weight-bold">Contas a Receber</h6>
                  <p class="mb-0 text-muted">
                    <i class="fas fa-calendar-alt"></i> Hoje
                  </p>
                </div>
                <span class="badge badge-pill badge-success">R$ {{ total_receber }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1 text-danger font-weight-bold">Contas a Pagar</h6>
                  <p class="mb-0 text-muted">
                    <i class="fas fa-calendar-alt"></i> Hoje
                  </p>
                </div>
                <span class="badge badge-pill badge-danger">R$ {{ total_pagar }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Contas Vencidas -->
      <div class="col-md-4 mb-4 d-flex">
        <div class="card shadow-lg border-0 rounded-lg flex-grow-1 card-min-height">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Contas Vencidas</h5>
          </div>
          <div class="card-body p-3">
            <b-table striped hover responsive="sm" borderless bordered outlined small :items="contas_vencidas"
              :fields="contaVencidaField" :per-page="perPage">
              <template v-slot:cell(data_vencimento)="row">
                {{
                  formatDate(row.item.data_vencimento) !== 'Invalid date'
                    ? formatDate(row.item.data_vencimento)
                    : row.item.data_vencimento
                }}
              </template>
            </b-table>
            <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"
              class="mt-3"></b-pagination>
          </div>
        </div>
      </div>

      <!-- Últimas Receitas Emitidas -->
      <div class="col-md-4 mb-4 d-flex">
        <div class="card shadow-lg border-0 rounded-lg flex-grow-1 card-min-height">
          <div class="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4">
            <h5 class="mb-0 font-weight-bold">Últimas Receitas Emitidas</h5>
            <button class="btn btn-outline-primary btn-sm" @click="abrirReceitas">Ver Todos</button>
          </div>
          <div class="card-body p-3">
            <b-table striped hover responsive="sm" borderless bordered outlined small :items="ultimas_receitas_emitidas"
              :fields="ultimasReceitasFields" :per-page="perPage">
              <template v-slot:cell(data_emissao)="row">
                {{ formatDate(row.item.data_emissao) }}
              </template>
              <template v-slot:cell(valor_nf)="row">
                R$ {{ row.item.valor_nf }}
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    </template>
    <loading :active.sync="isLoading" color="#008e75" :can-cancel="false"></loading>
  </Layout>
</template>
<style lang="scss">
/* Estilo principal do bloco */
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.5rem;
  /* Bordas mais suaves */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Sombra suavizada */
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  /* Interatividade */
}

.bloco:hover {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
}

/* Título principal do bloco */
.bloco .titulo {
  font-size: 24px;
  color: #008e75;
  margin-bottom: 15px;
  font-weight: bold;
  letter-spacing: 0.04rem;
}

/* Subtítulo */
.bloco .subtitulo {
  margin-bottom: 12px;
  color: #555;
  font-size: 18px;
  line-height: 1.5;
}

/* Divisória */
.bloco .borda {
  margin: 20px 0;
  border-bottom: solid 1px #edeff4;
}

/* Formulário centralizado */
.bloco .formulario {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

/* Botão principal */
.bloco .btn-webreceita {
  margin: 30px 0 10px;
  background-color: #008e75;
  padding: 10px 30px;
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  border: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.bloco .btn-webreceita:hover {
  background-color: #006f5a;
  transform: translateY(-2px);
}

.bloco .btn-webreceita.botaoTopo {
  float: right;
}

/* Botão de filtro */
.bloco .filterButton {
  margin: 30px 0 10px;
  background-color: #008e75;
  padding: 10px 30px;
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  border: none;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.bloco .filterButton:hover {
  background-color: #006f5a;
  transform: translateY(-2px);
}

/* Título do card */
.card-title {
  color: #007bff;
  font-weight: bold;
}

/* Ícone de temperatura mínima */
.temp-icon-min {
  transform: rotate(180deg);
}

/* Título do período */
.period-title {
  font-weight: bold;
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  text-transform: uppercase;
}

/* Gradiente no header */
.bg-gradient-light {
  background: linear-gradient(135deg, #f9f9f9, #e6e6e6);
  border-bottom: 1px solid #ddd;
  padding: 20px;
  text-align: center;
  border-radius: 10px 10px 0 0;
}

/* Cartão do período do tempo */
.weather-card {
  background: linear-gradient(135deg, #ffffff, #f8f8f8);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding: 20px;
  border-radius: 10px;
}

.weather-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Ícone do tempo */
.weather-icon {
  max-width: 60px;
  height: auto;
  margin-bottom: 10px;
}

/* Card header */
.card-min-height {
  height: 250px;
  /* Altura fixa */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Distribui o conteúdo uniformemente */
  overflow: hidden;
  /* Evita overflow de conteúdo */
}

/* Ajustar o corpo do card */
.card-body {
  padding: 15px;
}

/* Ajustar o cabeçalho do card */
.card-header {
  padding: 10px 15px;
  min-height: 50px;
}

/* Estilização geral do card */
.card {
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: 100px;
  /* Altura mínima reduzida */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Alinha conteúdo */
}

.card:hover {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
}

/* Texto descritivo */
.text-muted {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.4;
}

/* Tipografia geral */
h5 {
  font-size: 1.25rem;
  letter-spacing: 0.03rem;
  font-weight: bold;
}

h6 {
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  color: #333;
}

/* Ícones no weather card */
.weather-card i {
  margin-right: 5px;
  color: #555;
}

/* Suavidade em transições */
.card,
.weather-card,
.bloco .btn-webreceita,
.bloco .filterButton {
  transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
}

.system-update-notice {
  margin-bottom: 1.4rem;
  padding: 1rem 1.1rem;
  border: 1px solid #d8e7e1;
  border-radius: 18px;
  background: linear-gradient(135deg, #f7fbfa 0%, #ffffff 100%);
  box-shadow: 0 12px 30px rgba(15, 61, 52, 0.06);
}

.system-update-notice__hero {
  padding: 0 0 0.6rem;
}

.system-update-notice__hero h3 {
  margin: 0 0 0.35rem;
  color: #11493f;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.08;
}

.system-update-notice__hero p,
.system-update-notice__card span {
  color: #59746e;
  line-height: 1.4;
  font-size: 0.92rem;
}

.system-update-notice__cards {
  display: grid;
  gap: 0.6rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.system-update-notice__card {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 0.7rem;
  align-items: center;
  padding: 0.75rem 0.85rem;
  border: 1px solid rgba(0, 142, 117, 0.1);
  border-radius: 14px;
  background: linear-gradient(135deg, #f7fbfa 0%, #ffffff 100%);
}

.system-update-notice__card strong {
  display: block;
  margin-bottom: 0.08rem;
  color: #11493f;
  font-size: 0.95rem;
}

.system-update-notice__icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(0, 142, 117, 0.16) 0%, rgba(0, 142, 117, 0.06) 100%);
  color: #008e75;
}

.system-update-notice__icon-wrap svg {
  width: 17px;
  height: 17px;
}

/* Responsividade geral */
@media (max-width: 768px) {
  .system-update-notice {
    padding: 0.85rem;
  }

  .system-update-notice__hero h3 {
    font-size: 1.05rem;
  }

  .system-update-notice__cards {
    gap: 0.5rem;
    grid-template-columns: 1fr;
  }

  .system-update-notice__card {
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 0.6rem;
    padding: 0.65rem 0.75rem;
  }

  .system-update-notice__icon-wrap {
    width: 34px;
    height: 34px;
    border-radius: 10px;
  }

  .system-update-notice__icon-wrap svg {
    width: 15px;
    height: 15px;
  }

  .system-update-notice__hero p,
  .system-update-notice__card span {
    font-size: 0.85rem;
    line-height: 1.35;
  }

  .bloco {
    padding: 20px;
  }

  .bloco .titulo {
    font-size: 22px;
  }

  .bloco .subtitulo {
    font-size: 16px;
  }

  .btn-webreceita,
  .filterButton {
    padding: 8px 20px;
  }

  h5 {
    font-size: 1.1rem;
  }

  .card {
    min-height: 150px;
    /* Altura mínima menor em telas menores */
  }
}
</style>
